import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Appbar from "./Appbar";

const LayoutWrapper = ({ children, hideSidebar = false }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="flex flex-1 h-full w-full text-black">
      {/* Sidebar */}
      {!hideSidebar && (
        <>
          {/* Mobile overlay */}
          {open && (
            <div
              className="fixed inset-0 bg-black/40 z-40 md:hidden"
              onClick={() => setOpen(false)}
            />
          )}
          <div className={`fixed md:relative z-50 h-full bg-white transition-transform duration-200 ${open ? "translate-x-0" : "-translate-x-full"} md:translate-x-0`}>
            <Sidebar />
          </div>
        </>
      )}

      {/* Main content */}
      <div className="flex flex-col flex-1 h-full overflow-hidden">
        <Appbar setOpen={setOpen} />
        <div className="flex-1 overflow-auto bg-[#F8FAFC] px-5 py-6">
          {children}
        </div>
      </div>
    </div>
  );
};

export default LayoutWrapper;
